import { Button, Card, CardContent } from "alm-react-components";
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MyNoteIcon from "../../../assets/images/svgicons/my-note-icon.svg";

import useNotesTabDataHook from "../../../hooks/useNotesTabDataHook";
import { useLayoutEffect } from "react";
import PageLoader from "../../common/loader/PageLoader";

const NotesSection = () => {
  const { t } = useTranslation();
  const { notesData, loading } = useNotesTabDataHook();
  useLayoutEffect(() => {
    window.scroll(0, 0);
  }, []);
  const navigate = useNavigate();

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <div>
        <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
          <div className="flex justify-between items-center pl-2">
            <Button
              onClick={() => navigate(`/home/my-stance`)}
              variant="default"
              className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
            >
              <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
            </Button>
          </div>
          <h2
            className="text-3xl font-barlowLight mt-6 pl-2"
            dangerouslySetInnerHTML={{ __html: t("MyStance.myNotes") }}
          ></h2>

          <div className="grid md:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-6 mt-12">
            {notesData?.length > 0 ? (
              notesData?.map((res: any) => {
                return (
                  <>
                    <Card className="dark:bg-fillMidGrayCard h-full dark:text-white rounded-2xl border-0 pt-9 pb-6 flex flex-col flex-1">
                      <div className="mx-auto w-full flex justify-center">
                        <img
                          src={MyNoteIcon}
                          className=""
                          alt="My Note Icon Image"
                        />
                      </div>
                      <CardContent className="py-0">
                        <p className="text-2xl font-barlowLight text-white leading-tight text-center pt-5 min-h-[78px]">
                          {res?.programName
                            ? res?.programName
                            : res?.courseName}
                        </p>
                      </CardContent>
                      <div className="mt-auto p-6 pb-2 flex">
                        <Button
                          onClick={() =>
                            navigate(
                              `/program-notes?almCommentId=${
                                res?.programId
                                  ? res?.programId
                                  : res?.almCommentId
                              }`
                            )
                          }
                          variant="secondary"
                          className="text-base font-medium px-6 py-1 h-9 border w-full dark:bg-primary text-primary-foreground "
                          dangerouslySetInnerHTML={{
                            __html: t("MyStance.viewNotes"),
                          }}
                        ></Button>
                      </div>
                    </Card>
                  </>
                );
              })
            ) : (
              <div
                className="flex w-full justify-center text-2xl"
                dangerouslySetInnerHTML={{ __html: t("MyStance.noNotesFound") }}
              ></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NotesSection;
